import { get } from 'lodash';
import { Node_Type } from 'ricos-schema';
import { getResolvedCoverImage, getCustomCoverImage,
// @ts-expect-error
 } from '@wix/communities-universal/dist/src/services/get-post-cover';
import { resizeThumbnail } from './image-utils';
import { getVideoUrl } from './video-utils';
const getCoverFromRichContentVideo = (node, imageHost, videoHost) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (node.videoData) {
        const thumbnail = node.videoData.thumbnail || {};
        const videoUrl = ((_b = (_a = node.videoData.video) === null || _a === void 0 ? void 0 : _a.src) === null || _b === void 0 ? void 0 : _b.id)
            ? getVideoUrl({ videoHost, pathname: node.videoData.video.src.id })
            : (_d = (_c = node.videoData.video) === null || _c === void 0 ? void 0 : _c.src) === null || _d === void 0 ? void 0 : _d.url;
        if ((_e = thumbnail.src) === null || _e === void 0 ? void 0 : _e.id) {
            const resized = resizeThumbnail({
                pathname: ((_f = thumbnail.src) === null || _f === void 0 ? void 0 : _f.id) || '',
                width: thumbnail.width,
                height: thumbnail.height,
                imageHost,
            });
            return {
                thumbnail_url: resized.url,
                thumbnail_height: resized.height,
                thumbnail_width: resized.width,
                video_url: videoUrl,
            };
        }
        return {
            thumbnail_url: (_g = thumbnail.src) === null || _g === void 0 ? void 0 : _g.url,
            thumbnail_height: thumbnail.height,
            thumbnail_width: thumbnail.width,
            video_url: videoUrl,
        };
    }
    return;
};
export const getRichContentPostVideoEmbedCover = (content, imageHost, videoHost) => {
    const nodes = get(content, 'nodes', []);
    const video = nodes.find((node) => node.type === Node_Type.VIDEO);
    if (video === null || video === void 0 ? void 0 : video.videoData) {
        return getCoverFromRichContentVideo(video, imageHost, videoHost);
    }
    return undefined;
};
const getPostImageCover = (content) => {
    const nodes = get(content, 'nodes', []);
    const image = nodes.find((node) => node.type === Node_Type.IMAGE);
    if (image === null || image === void 0 ? void 0 : image.imageData) {
        return getCoverFromRichContentImage(image);
    }
    const gallery = nodes.find((node) => node.type === Node_Type.GALLERY);
    if (gallery === null || gallery === void 0 ? void 0 : gallery.galleryData) {
        return getCoverFromRichContentGallery(gallery);
    }
    return undefined;
};
export const getRichContentPostCover = (post, imageHost, videoHost) => {
    const resolvedCoverImage = getResolvedCoverImage(post);
    if (resolvedCoverImage) {
        return resolvedCoverImage;
    }
    let { imageMetadata, videoMetadata, isCustom, isEnabled } = getCustomCoverImage(post);
    if (!imageMetadata) {
        imageMetadata = getPostImageCover(post.content);
    }
    if (!imageMetadata) {
        videoMetadata = getRichContentPostVideoEmbedCover(post.content, imageHost, videoHost);
    }
    return {
        shouldRender: Boolean(imageMetadata || videoMetadata) && isEnabled,
        imageMetadata,
        videoMetadata,
        src: imageMetadata || get(videoMetadata, 'thumbnail_url'),
        isEnabled,
        isCustom,
    };
};
const getCoverFromRichContentImage = (node) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (node.imageData) {
        return {
            id: ((_b = (_a = node.imageData.image) === null || _a === void 0 ? void 0 : _a.src) === null || _b === void 0 ? void 0 : _b.id) || ((_d = (_c = node.imageData.image) === null || _c === void 0 ? void 0 : _c.src) === null || _d === void 0 ? void 0 : _d.url),
            file_name: ((_f = (_e = node.imageData.image) === null || _e === void 0 ? void 0 : _e.src) === null || _f === void 0 ? void 0 : _f.id) || ((_h = (_g = node.imageData.image) === null || _g === void 0 ? void 0 : _g.src) === null || _h === void 0 ? void 0 : _h.url),
            width: (_j = node.imageData.image) === null || _j === void 0 ? void 0 : _j.width,
            height: (_k = node.imageData.image) === null || _k === void 0 ? void 0 : _k.height,
        };
    }
    return;
};
const getCoverFromRichContentGallery = (node) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const firstGalleryItem = (_b = (_a = node.galleryData) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0];
    if (firstGalleryItem) {
        return {
            id: ((_e = (_d = (_c = firstGalleryItem.image) === null || _c === void 0 ? void 0 : _c.media) === null || _d === void 0 ? void 0 : _d.src) === null || _e === void 0 ? void 0 : _e.id) ||
                ((_h = (_g = (_f = firstGalleryItem.image) === null || _f === void 0 ? void 0 : _f.media) === null || _g === void 0 ? void 0 : _g.src) === null || _h === void 0 ? void 0 : _h.url),
            file_name: ((_l = (_k = (_j = firstGalleryItem.image) === null || _j === void 0 ? void 0 : _j.media) === null || _k === void 0 ? void 0 : _k.src) === null || _l === void 0 ? void 0 : _l.id) ||
                ((_p = (_o = (_m = firstGalleryItem.image) === null || _m === void 0 ? void 0 : _m.media) === null || _o === void 0 ? void 0 : _o.src) === null || _p === void 0 ? void 0 : _p.url),
            width: (_r = (_q = firstGalleryItem.image) === null || _q === void 0 ? void 0 : _q.media) === null || _r === void 0 ? void 0 : _r.width,
            height: (_t = (_s = firstGalleryItem.image) === null || _s === void 0 ? void 0 : _s.media) === null || _t === void 0 ? void 0 : _t.height,
        };
    }
    return;
};
//# sourceMappingURL=post-cover-utils.js.map